import React from "react";
import { useSelector } from "react-redux";

// Scss
import "./ChangeOrderDashboard.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import COIcon from "assets/icons/co-icon.svg";
import TTCIcon from "assets/icons/ttc.svg";
import TTCIconLight from "assets/icons/ttc-light.svg";
// import DashboardLoader from "assets/images/loader.gif";



// Importing Packages
import "animate.css";

function ChangeOrderDashboard() {
  const selectedTheme = useSelector((state) => state.globalConfig.theme);

  return (
    <>
     {/* Dropdowns Wrapper */}
     <section className="dropdowns-wrapper">
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Central</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Eastern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>North Western</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Northern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>S. Project</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Southern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
      </section>

      {/* Change Order Pane */}
      <section className="change-order-wrapper">
        <div className="change-order-container">
          <div className="cp-title">
            <img src={COIcon} alt="#" />
            <span>Change Order</span>
          </div>
          <div className="cp-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Change Order Table Section */}
      <section className="change-order-table-wrapper">
        <div className="change-order-table-container">
          <div className="container">
            <div className="head">
              <span>
              {
                      selectedTheme === 'dark'?<img src={TTCIcon} alt="#" />:<img src={TTCIconLight} alt="#" />
                    }
                Change Order
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Project Name</th>
                      <th>Project #</th>
                      <th>Sequence #</th>
                      <th>Title</th>
                      <th>VO Type</th>
                      <th>Creation Date</th>
                      <th>Contractor</th>
                      <th>Type</th>
                      <th>Assigned To</th>
                      <th>Task Recieved Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>120</td>
                      <td>201170542-C0-00001</td>
                      <td>123,342,344</td>
                      <td></td>
                      <td>07-06-2022 09:00:42</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>Water</td>
                      <td>Mansour M. Abuthnain</td>
                      <td>07-06-2022 09:00:42</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>120</td>
                      <td>201170542-C0-00001</td>
                      <td>123,342,344</td>
                      <td></td>
                      <td>07-06-2022 09:00:42</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ</td>
                      <td>Water</td>
                      <td>Mansour M. Abuthnain</td>
                      <td>07-06-2022 09:00:42</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChangeOrderDashboard;
